import { useCallback } from 'react';
import { useQueueContext } from 'presentation/components/Queue/QueueContext';
import { useFetchQueueRequestById } from './useFetchQueueRequestById';

export const useNavigateToGroup = () => {
  const { dispatch } = useQueueContext();
  const fetchQueueRequestById = useFetchQueueRequestById();

  const navigateToGroup = useCallback(
    (groupId: string) => {
      // Clear any previously selected request so the conversation panel shows a clean state
      // while the group parent is being fetched
      dispatch({ type: 'SET_SELECTED_ITEM', payload: null });
      dispatch({ type: 'SET_ACTIVE_GROUP_ID', payload: groupId });
      dispatch({ type: 'SET_ACTIVE_VIEW', payload: 'Groups' });
      fetchQueueRequestById(groupId)
        .then(group => {
          dispatch({ type: 'SET_SELECTED_ITEM', payload: group });
        })
        .catch(() => {
          // Fetch failed — user still lands in Groups view
        });
    },
    [dispatch, fetchQueueRequestById]
  );

  return { navigateToGroup };
};
